import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "@headlessui/react";
import React, { useState, useRef, useEffect, useCallback } from "react";
import ReactPlayer from "react-player";
import Slider from "react-slick";

const settings = {
  dots: false,
  slidesToShow: 2,
  rows: 1,
  speed: 3000,
  autoplay: true,
  autoplaySpeed: 3000,
  cssEase: "linear",
  infinite: true,
  arrows: true,
  pauseOnHover: false,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        infinite: true,
        dots: false,
        arrows: false,
        swipeToSlide: true,
        pauseOnHover: false,
      },
    },
  ],
};

const AchievementSection = ({ achievements }) => {
  const [modalEnabled, setModalEnabled] = useState({
    is_show: false,
    achievement: {
      name: "",
      description: "",
      from: "",
      to: "",
      thumbNail: "",
      videoUrl: "",
      thumbNail2: "",
    },
  });
  const sliderRef = useRef(null);
  const [isSliderReady, setIsSliderReady] = useState(false);

  // Initialize slider and start autoplay
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsSliderReady(true);

      // Manually trigger autoplay
      setTimeout(() => {
        if (sliderRef.current?.innerSlider?.autoPlay) {
          sliderRef.current.innerSlider.autoPlay();
        }
      }, 100);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  // Handle slider initialization
  const handleSliderInit = useCallback(
    (slider) => {
      sliderRef.current = slider;
      if (isSliderReady) {
        setTimeout(() => {
          if (slider?.innerSlider?.autoPlay) {
            slider.innerSlider.autoPlay();
          }
        }, 100);
      }
    },
    [isSliderReady],
  );

  return (
    <div className="w-full">
      <Slider ref={handleSliderInit} {...settings}>
        {achievements?.length > 0 &&
          achievements?.map((item, index) => (
            <div key={index} className="w-full">
              <div
                className="relative flex h-full w-[96%] cursor-pointer flex-col items-center justify-center font-light md:py-2"
                onClick={() => {
                  setModalEnabled(() => ({ is_show: true, achievement: item }));
                }}
              >
                <img src={item?.thumbNail} alt="" className="w-full"></img>
                <div className="absolute top-3 left-3 z-20 flex items-center gap-0.5">
                  <h2 className="font-bold text-white/80">{item?.name}</h2>
                  <img
                    src="https://img.learntube.ai/public-assets/Info.png?updatedAt=1704268543580"
                    alt=""
                    className="ml-0.5 inline h-5 w-5"
                  />
                </div>
                <div className="absolute bottom-3 flex w-full items-center justify-evenly gap-2 px-2 text-sm font-medium">
                  <div className="flex-1 leading-4">
                    <p>{item.from}</p>
                  </div>
                  <img
                    src="https://img.learntube.ai/public-assets/Post%20Payment/Arrow.png?updatedAt=1704522242977"
                    width={26}
                    height={26}
                    alt=""
                    className="h-[26px] w-auto"
                  />
                  <div className="text-end flex-1">
                    <p>{item.to}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </Slider>
      {modalEnabled?.is_show && (
        <Dialog
          open={modalEnabled?.is_show}
          onClose={() => {
            setModalEnabled((prev) => ({ ...prev, is_show: false }));
          }}
          as="div"
          style={{ zIndex: "9999999999" }}
          className="fixed inset-0 z-10  -mt-10 flex flex-col items-center justify-center md:my-4 md:justify-start"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
          <Dialog.Title />
          <Dialog.Description />
          <div className="relative z-50 max-h-[650px] w-[90%] max-w-lg overflow-y-scroll rounded-2xl bg-[#2D4F71] text-white">
            <div
              className="absolute right-3 top-3 cursor-pointer"
              onClick={() =>
                setModalEnabled((prev) => ({ ...prev, is_show: false }))
              }
            >
              <FontAwesomeIcon icon={faXmark} className="text-2xl" />
            </div>
            <div className="z-[9999]">
              <ReactPlayer
                url={modalEnabled?.achievement?.videoUrl}
                width="100%"
                height={"229px"}
              />
            </div>
            <div className="p-3">
              <div className="flex items-center gap-2">
                <div className="h-9 w-9">
                  <img
                    src={modalEnabled?.achievement?.thumbNail}
                    alt=""
                    className="h-full w-full rounded-full object-cover"
                  />
                </div>
                <div>
                  <h3 className="font-semibold">
                    {modalEnabled?.achievement?.name}
                  </h3>
                  <div className="flex items-center gap-2">
                    <img
                      src="https://img.learntube.ai/public-assets/Post%20Payment/Vector.png?updatedAt=1706102191445"
                      width={15}
                      height={15}
                      className="rounded-full"
                      alt=""
                    />
                    <p className="text-xs text-white/60">LearnTube Max User</p>
                  </div>
                </div>
              </div>
              <div className="mt-3 flex w-full items-center justify-evenly gap-2 px-2 text-lg font-medium">
                <div className="flex-1 leading-5">
                  <p>{modalEnabled?.achievement?.from}</p>
                </div>
                <img
                  src="https://img.learntube.ai/public-assets/Post%20Payment/Arrow.png?updatedAt=1704522242977"
                  width={26}
                  height={26}
                  alt=""
                  className="h-[26px] w-auto"
                />
                <div className="text-end flex-1 leading-5">
                  <p>{modalEnabled?.achievement?.to}</p>
                </div>
              </div>
              <div className="mt-4 flex flex-col gap-2 text-sm text-white/80">
                {modalEnabled?.achievement?.description
                  ?.split("\n")
                  ?.map((item, index) => (
                    <p key={index} className="leading-[18px]">
                      {item}
                    </p>
                  ))}
              </div>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default AchievementSection;
